import moment from "moment";

export const checkForSessionConflicts = (
  sessions,
  startTime,
  currentSessionId,
  sessionDuration,
  currentSessionName,
) => {
  let finalReturnValue = {
    title: false,
    diff: false,
    isEarly: false,
    reachedEnd: false,
    isLate: false,
  };
  const format = "HH:mm:ss";
  const TwelveHourFormat = "h:mma";
  const otherSessions = sessions.filter(
    (session) => session.sessionId !== currentSessionId,
  );
  const currentSessionMomentTime = moment(startTime, format);
  const currentSessionStartTime = currentSessionMomentTime.format(format);

  const currentSessionMomentEndTime = moment(
    currentSessionStartTime,
    format,
  ).add(sessionDuration, "minutes");
  const currentSessionEndTime = currentSessionMomentEndTime.format(format);

  const start12HoursFormat = currentSessionMomentTime
    .format(TwelveHourFormat)
    .toString()
    .slice(-2);
  const end12HoursFormat = currentSessionMomentEndTime
    .format(TwelveHourFormat)
    .toString()
    .slice(-2);

  // if the ending time is on next day
  if (start12HoursFormat === "pm" && end12HoursFormat === "am") {
    return { reachedEnd: true };
  }

  for (let i = 0; i < otherSessions.length; i += 1) {
    const element = otherSessions[i];
    const compareStartTime = moment(element.startTime, format).format(format);

    const compareEndMomentTime = moment(element.startTime, format).add(
      // for 1 min break
      element.sessionDuration + 1,
      "minutes",
    );

    const newSessionTime = moment(currentSessionStartTime, TwelveHourFormat);
    const previousSessionTime = moment(compareStartTime, TwelveHourFormat);

    // checking if session is in order or not
    if (
      Number(currentSessionName.split(" ")[1]) >
      Number(element.title.split(" ")[1])
    ) {
      if (newSessionTime.isBefore(previousSessionTime)) {
        return { isEarly: element.title };
      }
    } else if (newSessionTime.isAfter(previousSessionTime)) {
      return { isLate: element.title };
    }

    if (newSessionTime.isSame(previousSessionTime)) {
      return { title: element.title };
    }

    const compareEndTime = compareEndMomentTime.format(format);

    if (
      moment(currentSessionStartTime, format).isBefore(
        moment(compareStartTime, format),
      )
    ) {
      if (
        !moment(currentSessionEndTime, format).isBefore(
          moment(compareStartTime, format),
        )
      ) {
        finalReturnValue = {
          title: element.title,
          diff: compareEndMomentTime.diff(currentSessionMomentTime, "seconds"),
        };
      }
    }
    if (
      moment(currentSessionStartTime, format).isBetween(
        moment(compareStartTime, format),
        moment(compareEndTime, format),
      )
    ) {
      finalReturnValue = {
        title: element.title,
        diff: compareEndMomentTime.diff(currentSessionMomentTime, "seconds"),
      };
    }
  }
  return finalReturnValue;
};
